// extracted by mini-css-extract-plugin
export default {"code":"Code_code__PLK-a","codeBlock":"Code_codeBlock__+kx33"};